import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';
import { Moment } from 'moment';

export enum BankSlipBillStatus {
  issued = 'EMITIDO',
  rejected = 'REJEITADO',
  failure = 'FALHA',
  saved = 'SALVO',
  registered = 'REGISTRADO',
  liquidated = 'LIQUIDADO',
  downloaded = 'BAIXADO',
}

export enum BankSlipFilterBy {
  emission = 'EMISSION',
  due = 'DUE',
}

export const BankSlipFilterByConvert = {
  [BankSlipFilterBy.emission]: 'Emissão',
  [BankSlipFilterBy.due]: 'Vencimento',
};

export enum BankSlipInvoiceSituation {
  authorized = 'AUTHORIZED',
  canceled = 'CANCELED',
  denied = 'DENIED',
  inTyping = 'IN_TYPING',
  processing = 'PROCESSING',
  processingCancellation = 'PROCESSING_CANCELLATION',
  replaced = 'REPLACED',
  validated = 'VALIDATED',
}

export const BankSlipInvoiceSituationConvert = {
  [BankSlipInvoiceSituation.authorized]: 'Autorizada',
  [BankSlipInvoiceSituation.canceled]: 'Cancelada',
  [BankSlipInvoiceSituation.denied]: 'Negada',
  [BankSlipInvoiceSituation.inTyping]: 'Em Digitação',
  [BankSlipInvoiceSituation.processing]: 'Processamento',
  [BankSlipInvoiceSituation.processingCancellation]:
    'Processamento de cancelamento',
  [BankSlipInvoiceSituation.replaced]: 'Substituída',
  [BankSlipInvoiceSituation.validated]: 'Validada',
};

export interface BankSlipReportRequest {
  billStatus?: BankSlipBillStatus;
  companiesIds?: number[];
  customerIds?: number[];
  filterBy: BankSlipFilterBy;
  finalDate: string;
  initialDate: string;
  insurerIds?: number[];
  invoiceSituation?: BankSlipInvoiceSituation;
}

export interface BankSlipReportFormValues extends ReportDateInterface {
  initialDate: Moment;
  finalDate: Moment;
  billStatus?: BankSlipBillStatus;
  filterBy: BankSlipFilterBy;
  invoiceSituation?: BankSlipInvoiceSituation;
  customerIds?: number[];
  insurerIds?: number[];
}
